import React, {useState, useRef} from 'react';
import useOutsideClick from '@ibibo/use-outside-click';
import * as S from './TextInput.styles';

const TextInput = ({
  id,
  name,
  hasRupeesSymbol,
  placeholder,
  onChange,
  width,
  calendarIcon,
  value,
  type = 'text',
  ccdeCookie = 'IN',
  isTooltipTrue = false,
  toolTipHeading,
  toolTipText,
}) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleTooltip = () => {
    setIsTooltipOpen(true);
  };
  const tooltipRef = useRef();
  useOutsideClick(tooltipRef, () => {
    if (isTooltipOpen) {
      setIsTooltipOpen(false);
    }
  });

  return (
    <S.InputBox hasRupeesSymbol={hasRupeesSymbol} width={width}>
      {hasRupeesSymbol && <S.Symbol>{ccdeCookie === 'AE' ? 'AED' : '₹'}</S.Symbol>}
      {calendarIcon && <span className="sprite icCalendar"></span>}
      <input
        type={type}
        id={id}
        name={name}
        value={value}
        placeholder={placeholder}
        onClick={handleTooltip}
        onChange={e => onChange(e.target.value)}
        ref={tooltipRef}
      />
      {isTooltipTrue && isTooltipOpen && (
        <S.Tooltip>
          <S.TooltipHeading>
            <S.TooltipHeadingText>{toolTipHeading && toolTipHeading}</S.TooltipHeadingText>
            <S.TooltipCloseBtn onClick={() => setIsTooltipOpen(false)}></S.TooltipCloseBtn>
          </S.TooltipHeading>
          <S.TooltipTxt>{toolTipText && toolTipText}</S.TooltipTxt>
        </S.Tooltip>
      )}
    </S.InputBox>
  );
};

export default TextInput;
